import { api } from "@/lib/api";


export const QUESTIONS = [
  { key: "match", q: "Do you put at least 5% of your pay into the TSP?", hint: "Counts whether you set a percentage or a fixed dollar amount per paycheck. FERS employees get the full 5% agency match only if they put in at least 5% of pay.",
    options: [{ v: "yes", t: "Yes, 5% or more (or the dollar equivalent)" }, { v: "no", t: "No, less than 5%" }, { v: "unsure", t: "I'm not sure" }] },
  { key: "date", q: "How confident are you about your retirement date?", hint: "Think MRA, MRA+10, 60 with 20 years, or 62 with 5.",
    options: [{ v: "very", t: "Very confident, I know my date" }, { v: "some", t: "I have a rough idea" }, { v: "none", t: "No idea yet" }] },
  { key: "seen", q: "Have you ever seen your projected pension, TSP and Social Security income in one place?", hint: "One monthly number for retirement, not three separate statements.",
    options: [{ v: "yes", t: "Yes, I have the full picture" }, { v: "no", t: "No, never" }] },
];

export const RESULTS = {
  "on-track": {
    title: "You look on track", short: "I'm on track", accent: "on track",
    body: "You're capturing the full agency match and you know when you can retire. Next step: confirm the exact pension and monthly income behind that date.",
    tips: ["Check your High-3 and FERS pension estimate", "Run your best retirement date by month", "See your TSP balance at retirement"],
  },
  boost: {
    title: "Time to boost your TSP contributions", short: "I need to boost my TSP contributions", accent: "boost",
    body: "If you put in less than 5%, you're leaving free agency match money on the table every paycheck. Even a 1% raise compounds into tens of thousands by retirement.",
    tips: ["See exactly how much match you're missing", "Model a higher contribution in the what-if simulator", "Plan around the 2026 TSP limits"],
  },
  "eye-opener": {
    title: "Your retirement picture is about to click", short: "I was shocked by what this app showed me", accent: "eye-opener",
    body: "Most federal employees never see their pension, FERS Supplement, Social Security and TSP income together. PillarWealth puts it all on one screen, free.",
    tips: ["Get one projected monthly retirement income", "Find your earliest penalty-free retirement date", "Track your TSP with official daily prices"],
  },
};

export function scoreQuiz(a) {
  if (a.match !== "yes") return "boost";
  if (a.date === "very" && a.seen === "yes") return "on-track";
  return "eye-opener";
}

const SITE = process.env.REACT_APP_SITE_URL;
export const shareUrl = (result) => `${SITE}/api/check/${result}`;
const sentArrivals = new Set();
export const trackQuiz = (result, kind) => {
  if (kind === "arrival") { if (sentArrivals.has(result)) return; sentArrivals.add(result); }
  api.post("/check/event", { result, kind }).catch(() => {});
};
export const postText = (result) => `I tried PillarWealth, a free retirement app for federal and military employees. My quiz result: ${RESULTS[result].short}. Try the app yourself and tell us what you think:`;
